import { useCallback, useEffect, useState } from 'react'
import { CellProps } from 'react-table'
import { Link } from 'react-router-dom'
import BaseTable from '../../components/BaseTable/BaseTable'
import DashboardWrapper from '../../components/MainDashboardWrapper/DashboardWrapper'
import { getAllUsers } from './helper'

type Props = {}

export default function AllUsersPage({}: Props) {
  const [users, setUsers] = useState([])

  const loadPage = useCallback(() => {
    getAllUsers().then((res) => {
      setUsers(res.data)
    })
  }, [])

  useEffect(() => {
    loadPage()
  }, [loadPage])

  const columns: any[] = [
    {
      Header: 'Name',
      accessor: 'displayName',
      Cell: (cellProps: CellProps<any>) => {
        return (
          <Link className="no-underline" to={`/all-users/${cellProps.row.original.uuid}`}>
            {cellProps.value}
          </Link>
        )
      },
    },
    {
      Header: 'Email',
      accessor: 'email',
    },
    {
      Header: 'Phone',
      accessor: 'phoneNumber',
    },
    {
      Header: 'Type',
      accessor: 'isProvider',
      Cell: (cellProps: CellProps<any>) => {
        return cellProps.value ? 'Coach' : 'Client'
      },
    },
  ]

  return (
    <DashboardWrapper page="all-users" title="All Users">
      <BaseTable data={users} columns={columns} />
    </DashboardWrapper>
  )
}
